import React from "react";
import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import "suneditor/dist/css/suneditor.min.css";
export default function Listfileupload(props) {
  const { tenfile, xoafile } = props;
  const xoa = (id, key) => {
    xoafile(id, key);
  };
  return (
    <FormControl style={{ width: "99%", marginTop: "10px", marginLeft: "4px" }}>
      {tenfile.map((prop, i) => {
        return (
          <li key={i}>
            {prop.filename}
            <FormControl style={{ marginTop: "1px" }}>
              <CloseIcon onClick={() => xoa(i, prop.key)} />
            </FormControl>
          </li>
        );
      })}
    </FormControl>
  );
}

Listfileupload.propTypes = {
  tenfile: PropTypes.array,
  xoafile: PropTypes.func,
};
